// Mirrors STAGE_STYLES / ALL_STAGES in CRMQueue.jsx — keep the two in sync.
// Hex values are the Tailwind dot colors used on the queue's stage badges.
export const STAGE_COLOR_BY_ID = {
  1: "#10b981",  // emerald-500 — Ready to Schedule
  2: "#3b82f6",  // blue-500    — First Call / Left Message
  3: "#6366f1",  // indigo-500  — Second Call
  4: "#f59e0b",  // amber-500   — Third Call / No Response
  5: "#a855f7",  // purple-500  — Scheduled Initial Visit
  6: "#f97316",  // orange-500  — Call to Reschedule (No-Show)
  7: "#fb923c",  // orange-400  — Call to Reschedule (Canceled)
  8: "#94a3b8",  // slate-400   — Closed: Completed Initial Visit
  9: "#94a3b8",  // slate-400   — Closed: No Response
  10: "#94a3b8", // slate-400   — Closed: Patient Decline Services
  11: "#94a3b8", // slate-400   — Closed: Canceled by Attorney
  12: "#94a3b8", // slate-400   — Closed: Continue Docs Sent
  13: "#0ea5e9", // sky-500     — Proposed Times
  14: "#14b8a6", // teal-500    — Network Suggested
  15: "#059669", // emerald-600 — Network Confirmed
  16: "#d946ef", // fuchsia-500 — Needs Patient Confirmation
};

export const DEFAULT_STAGE_COLOR = "#3b82f6";

// CRM statuses v2: with STATUS_NAMES_V2 on, lib/stagesV2.js sets colours
// from GET /crm/stages (ids 17-24 included). Off: never set, nothing changes.
let STAGE_COLOR_OVERRIDES = null;
export function setStageColorOverrides(map) {
  STAGE_COLOR_OVERRIDES = map || null;
}

export function stageColor(stageId) {
  if (STAGE_COLOR_OVERRIDES && STAGE_COLOR_OVERRIDES[stageId]) return STAGE_COLOR_OVERRIDES[stageId];
  return STAGE_COLOR_BY_ID[stageId] || DEFAULT_STAGE_COLOR;
}

// Intake actions logged to audit_events by the New Referral Intake flow.
// Labels mirror INTAKE_ACTION_LABELS in backend activity_report_router.py
// (used in the CSV) — keep the two in sync.
export const INTAKE_ACTION_META = {
  intake_ready_updated:                 { label: "Marked Ready",          color: "#0ea5e9" }, // sky-500
  intake_billing_updated:               { label: "Billing Updated",       color: "#14b8a6" }, // teal-500
  intake_payor_updated:                 { label: "Payor Updated",         color: "#22c55e" }, // green-500
  referral_field_edited:                { label: "Field Edited",          color: "#8b5cf6" }, // violet-500
  intake_referral_cancelled:            { label: "Cancelled",             color: "#ef4444" }, // red-500
  intake_referral_uncancelled:          { label: "Un-cancelled",          color: "#f59e0b" }, // amber-500
  intake_pending_moved_to_incomplete:   { label: "Moved to Incomplete",   color: "#f97316" }, // orange-500
  intake_incomplete_moved_to_pending:   { label: "Moved to Pending",      color: "#3b82f6" }, // blue-500
  intake_incomplete_moved_to_cancelled: { label: "Incomplete → Cancelled", color: "#64748b" }, // slate-500
};

export function intakeActionMeta(action) {
  return INTAKE_ACTION_META[action] || { label: action, color: "#94a3b8" };
}
